import { Record } from "immutable"

import { normaliseModel, hydrateModel, updateChangeModel } from "../model-utils"
import { idify } from "../../reducers/paging/paging-reducer-utils"

const BaseMapModel = new Record({
    id: "",
    can_edit: false,
    can_view: true,
    description: "",
    displayName: "",
    co_curator: "",
    dimensions: [],
    image_url: "",
    tm_image_url: "",
    imagePreviewURL: undefined,
    imageCopyURL: undefined,
    name: "",
    nonEditOwners: [],
    nonEditViewers: [],
    owners: [],
    status: "Active",
    type: "",
    viewers: []
})

export class MapModel extends BaseMapModel {
    constructor(mapModelObject) {
        super({
            ...mapModelObject,
            viewers: mapModelObject
                ? mapModelObject.viewers.map(addDisplayName)
                : [],
            owners: mapModelObject
                ? mapModelObject.owners.map(addDisplayName)
                : []
        })
    }

    set(key, value) {
        if (key === "viewers" || key === "owners")
            value = (value || []).map(addDisplayName)
        return super.set(key, value)
    }
}

function addDisplayName(viewerOwner) {
    let suffix = ""
    if (viewerOwner.label && viewerOwner.name !== "Public") {
        suffix = ` (${viewerOwner.label})`
    }
    return {
        ...viewerOwner,
        displayName: `${viewerOwner.name}${suffix}`
    }
}

const MapCreateAPIModel = new Record({
    description: "",
    dimensions: [],
    name: "",
    owners: [],
    status: "Active",
    viewers: []
})

export const normalisingFields = ["dimensions", "topics"]
export const addRemoveFields = ["dimensions", "owners", "viewers"]

export const normalise = map => normaliseModel(map, ...normalisingFields)
export const enrichOwnersViewers = map => ({
    ...map,
    owners: (map.owners || [])
        .filter(({ can_remove }) => can_remove !== false)
        .map(addDisplayName),
    nonEditOwners: (map.owners || [])
        .filter(({ can_remove }) => can_remove === false)
        .map(addDisplayName),
    viewers: (map.viewers || [])
        .filter(({ can_remove }) => can_remove !== false)
        .map(addDisplayName),
    nonEditViewers: (map.viewers || [])
        .filter(({ can_remove }) => can_remove === false)
        .map(addDisplayName)
})
export const hydrate = (map, ...entityStates) => {
    const partiallyHydratedMap = hydrateModel(map, ["dimensions"], entityStates)
    return {
        ...partiallyHydratedMap,
        dimensions: partiallyHydratedMap.dimensions.map(dimension => ({
            ...dimension,
            // As "topics" is index 1 in normalising fields, it will end up in entityStates as index 1
            topics: dimension.topics.map(id => entityStates[1][id])
        }))
    }
}

export const updateMapChangeModel = (name, value, changeModel, workingModel) =>
    updateChangeModel(name, value, changeModel, workingModel, addRemoveFields)

export const newMapToAPI = map => {
    map = new MapCreateAPIModel(map)
    if (map)
        map = addRemoveFields.reduce(
            (map, field) => map.set(field, idify(map.get(field))),
            map
        )
    return map
}
